module.exports = __webpack_public_path__ + "static/media/logo.39c5f3c6.svg";